import { ErrorTypeForSearch } from "./Form";

export enum RESULT {
  PENDING,
  SUCCESS,
  FAIL,
  CANCELLED,
  ERROR,
}

export interface AppointmentResult {
  status: RESULT;
  bookingNo?: string;
  locationName?: string;
  bookingTime?: string;
  enquiryPhoneNo?: string;
  error?: ErrorTypeForSearch;
}
